export default __webpack_public_path__ + "static/media/44t.7a0536c3.jpg";